// React-Screen CHelpScreen ("Benutzerhandbuch") - NEU am 23.8.2026.
// Runbook: tools/REACT-STRANGLER.md.
//
// Das ist KEIN Port, sondern ein Feature auf Nutzer-Wunsch: die
// "Handbuch"-Taste des Anmeldebildschirms gab es zwar seit jeher, aber ihre
// Funktion begann mit `return;` - sie tat nichts. Der gleichnamige alte
// CHelpScreen war toter Code und ist am 23.8.2026 geloescht worden; hier
// entsteht er neu und zeigt das tatsaechliche Benutzerhandbuch.
//
// Aufbau, auf einen Touch-Bildschirm hin gebaut:
//  - links das Inhaltsverzeichnis (83 Kapitel, eingerueckt nach Ebene),
//    antippen springt auf die Seite,
//  - rechts die Handbuchseite als Bild (lib/handbuch/seite-NN.jpg),
//    scrollbar, dazu grosse Blaetter- und Scrolltasten,
//  - ueber der Seite ein Hinweis, wenn die Testsuite fuer dieses Kapitel
//    eine Abweichung zwischen Handbuch und dieser Kassa nachgewiesen hat.
//    Das Handbuch ist von 2006; ohne diesen Hinweis wuerde der Bildschirm
//    an mehreren Stellen etwas Falsches behaupten.
//
// EIGENE CSS-Klassen (CHelpFrame...), nicht CFrame: dieser Bildschirm ist
// ein Kind des Anmeldeschirms, und lib/css/pos.css enthaelt
// `.Login .CFrame { position:absolute; top:17%; left:21%; height:70%; ... }`.
// Diese Regeln haben beim ersten Wurf den Bedienbalken quer ueber die Seite
// gelegt (er setzte nur `bottom`, `top` kam aus der CSS). Ein neuer
// Bildschirm hat keinen Grund, fremde Klassen zu tragen.
//
// Die Bedienelemente haengen ABSICHTLICH nicht am Legacy-Dispatcher: der
// sperrt waehrend jedes Ereignisses kurz (zwei schnelle Klicks zaehlen nur
// einmal - im Runbook beschrieben), was beim Blaettern und Scrollen stoert.
// Hier gibt es kein Legacy-Verhalten zu erhalten, also normale
// React-Ereignisse. Aussehen bleibt ueber die bekannten CSS-Klassen gleich.
import { defineReactScreen } from '../bridge.js';
import { HANDBUCH_UNTERTITEL, HANDBUCH_KAPITEL } from '../handbuch.js';

// Seit 26.8.2026 zeigt der Schirm ECHTEN TEXT statt eingescannter Seiten:
// das alte Fremd-PDF von 2006 ist entfallen (Fremdlogo auf jeder Seite,
// Funkscanner-Kapitel, veralteter Inhalt). Geblaettert wird jetzt durch die
// Kapitel MIT Text; reine Ueberschriften sind nicht anwaehlbar.
// Damit entfallen auch die frueheren "Weicht ab"-Hinweiskaesten - was die
// Kassa tut, steht jetzt einfach richtig im Text.
const LESBARE = HANDBUCH_KAPITEL.filter((k) => k.text);

function HelpScreen({ bridge }) {
  const nr = bridge.state.kapitel;              // Kapitelnummer, z.B. "3.3"
  const index = Math.max(0, LESBARE.findIndex((k) => k.nr === nr));
  const aktuell = LESBARE[index];

  const blaettern = (delta) => {
    const neu = LESBARE[Math.min(LESBARE.length - 1, Math.max(0, index + delta))];
    if (neu && neu.nr !== nr) bridge.zeigeKapitel(neu.nr);
  };

  return (
    <>
      {/* Kopfzeile - wie in den uebrigen Vollbild-Screens */}
      <div {...bridge.el('0', 'CFrame')} className="CHelpFrame CHelpKopf"
           style={{ position: 'absolute', left: '0px', top: '0px', height: '6.8%',
                    width: '100%', backgroundColor: '#EFEFE6',
                    borderBottom: '1px solid #BBBBBB' }}>
        <p {...bridge.el('0:0', 'CCaption')} className="CCaption"
           style={{ position: 'absolute', left: '5px', top: '7px',
                    fontSize: '3.5vh', fontWeight: 'bold' }}>Benutzerhandbuch</p>
        <p {...bridge.el('0:1', 'CCaption')} className="CCaption"
           style={{ position: 'absolute', left: '30vw', top: '1.6vh', fontSize: '2vh',
                    color: '#555555' }}>{HANDBUCH_UNTERTITEL}</p>
        <div {...bridge.el('0:2', 'CPushButton')} className="CPushButton"
             onClick={() => bridge.schliessen()}
             style={{ position: 'absolute', right: '0.5%', top: '0px', width: '3%', height: '85%',
                      backgroundImage: 'url(lib/img/08_X.png)', backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center' }} />
      </div>

      {/* Inhaltsverzeichnis */}
      <div {...bridge.el('1', 'CFrame')} className="CHelpFrame"
           style={{ position: 'absolute', left: '1%', top: '8%', width: '26%', height: '83%',
                    borderStyle: 'solid', borderWidth: '2px', overflowY: 'auto',
                    backgroundColor: '#FFFFFF' }}>
        {HANDBUCH_KAPITEL.map((k, i) => {
          const anwaehlbar = !!k.text;
          const aktiv = anwaehlbar && k.nr === nr;
          return (
            <div key={i} className="CPushButton"
                 onClick={anwaehlbar ? () => bridge.zeigeKapitel(k.nr) : undefined}
                 style={{
                   position: 'relative', display: 'block', width: 'auto',
                   margin: '2px 4px', padding: '6px 8px',
                   paddingLeft: 8 + (k.tiefe - 1) * 18 + 'px',
                   fontSize: k.tiefe === 1 ? '2.1vh' : '1.8vh',
                   fontWeight: k.tiefe === 1 ? 'bold' : 'normal',
                   textAlign: 'left', whiteSpace: 'normal',
                   color: '#000000',
                   backgroundColor: aktiv ? '#D9E2F0' : 'transparent',
                   border: aktiv ? '1px solid #839AE0' : '1px solid transparent',
                 }}>
              {k.nr} {k.titel}
            </div>
          );
        })}
      </div>

      {/* Das Inhaltsverzeichnis braucht eigene Scrolltasten: die Kassa wird
          ueber einen Touch-Bildschirm bedient, und die uebrigen Listen der
          App blaettern aus demselben Grund ueber Tasten statt ueber Ziehen. */}
      <div {...bridge.el('4', 'CFrame')} className="CHelpFrame"
           style={{ position: 'absolute', left: '1%', top: '91.5%', width: '26%', height: '7%' }}>
        <div className="CPushButton" onClick={() => bridge.scrolleListe(-240)}
             style={{ position: 'absolute', left: '0%', top: '0px', width: '48%', height: '100%',
                      fontSize: '2.2vh' }}>&#9650;</div>
        <div className="CPushButton" onClick={() => bridge.scrolleListe(240)}
             style={{ position: 'absolute', right: '0%', top: '0px', width: '48%', height: '100%',
                      fontSize: '2.2vh' }}>&#9660;</div>
      </div>

      {/* Seitenanzeige */}
      <div {...bridge.el('2', 'CFrame')} className="CHelpFrame"
           style={{ position: 'absolute', left: '28.5%', top: '8%', width: '62%', height: '83%',
                    borderStyle: 'solid', borderWidth: '2px', overflowY: 'auto',
                    backgroundColor: '#FFFFFF', textAlign: 'center' }}>
        <div style={{ textAlign: 'left', padding: '10px 16px', fontSize: '2.0vh',
                      lineHeight: '1.45' }}>
          <p style={{ fontSize: '2.6vh', fontWeight: 'bold', margin: '0 0 10px 0' }}>
            {aktuell ? aktuell.nr + ' ' + aktuell.titel : ''}
          </p>
          <div dangerouslySetInnerHTML={{ __html: aktuell ? aktuell.text : '' }} />

          {/* Schritt fuer Schritt, mit Bild aus der ECHTEN Kassa.
              Erzeugt von tests/handbuch-bilder.js - nach Aenderungen an der
              Oberflaeche neu laufen lassen. */}
          {aktuell && aktuell.schritte ? (
            <div style={{ marginTop: '14px' }}>
              <p style={{ fontWeight: 'bold', margin: '0 0 8px 0' }}>Schritt f&uuml;r Schritt</p>
              {aktuell.schritte.map((s, i) => (
                <div key={i} style={{ margin: '0 0 14px 0' }}>
                  <p style={{ margin: '0 0 5px 0' }}>
                    <b style={{ display: 'inline-block', minWidth: '1.6em' }}>{i + 1}.</b>{s.text}
                  </p>
                  {s.bild ? (
                    <img src={`lib/handbuch/${s.bild}.jpg`} alt={s.text}
                         style={{ display: 'block', maxWidth: '96%', margin: '0 0 0 1.6em',
                                  border: '1px solid #BBBBBB' }} />
                  ) : null}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      {/* Blaettern und Scrollen */}
      <div {...bridge.el('3', 'CFrame')} className="CHelpFrame"
           style={{ position: 'absolute', left: '28.5%', top: '91.5%', width: '62%', height: '7%' }}>
        <div className="CPushButton" onClick={() => blaettern(-1)}
             style={{ position: 'absolute', left: '0%', top: '0px', width: '18%', height: '100%',
                      fontSize: '2.2vh' }}>&#9664; Zur&uuml;ck</div>
        <p {...bridge.el('3:0', 'CCaption')} className="CCaption"
           style={{ position: 'absolute', left: '22%', top: '0.6vh', fontSize: '2.2vh',
                    fontWeight: 'bold' }}>{`Kapitel ${index + 1} von ${LESBARE.length}`}</p>
        <div className="CPushButton" onClick={() => bridge.scrolleKapitel(-260)}
             style={{ position: 'absolute', left: '42%', top: '0px', width: '8%', height: '100%',
                      fontSize: '2.2vh' }}>&#9650;</div>
        <div className="CPushButton" onClick={() => bridge.scrolleKapitel(260)}
             style={{ position: 'absolute', left: '52%', top: '0px', width: '8%', height: '100%',
                      fontSize: '2.2vh' }}>&#9660;</div>
        <div className="CPushButton" onClick={() => blaettern(1)}
             style={{ position: 'absolute', right: '0%', top: '0px', width: '18%', height: '100%',
                      fontSize: '2.2vh' }}>Weiter &#9654;</div>
      </div>
    </>
  );
}

export const CHelpScreen = defineReactScreen({
  className: 'CHelpScreen',
  addclass: 'CHelpScreen',
  htmlType: 'div',
  Screen: HelpScreen,
  rootStyles: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: '0px',
    top: '0px',
    zIndex: '2',
    backgroundColor: '#F8F8F8',
  },
  initialState: { kapitel: LESBARE[0].nr },
  methods: {
    // Springt auf ein Kapitel und setzt die Anzeige wieder nach oben - sonst
    // landet man mitten im neuen Kapitel, wenn vorher gescrollt war.
    zeigeKapitel(bridge, nr) {
      bridge.update({ kapitel: nr });
      const anzeige = document.getElementById(bridge.childId('2'));
      if (anzeige) anzeige.scrollTop = 0;
    },
    scrolleKapitel(bridge, betrag) {
      const anzeige = document.getElementById(bridge.childId('2'));
      if (anzeige) anzeige.scrollTop += betrag;
    },
    scrolleListe(bridge, betrag) {
      const liste = document.getElementById(bridge.childId('1'));
      if (liste) liste.scrollTop += betrag;
    },
    schliessen(bridge) {
      bridge.removeMe();
    },
  },
});
